import { Base64 } from 'js-base64';
const ELEMENT_ID_PREFIX = 'CEIBA_ELEMENT_'; // 自动生成ID的前缀
const elementIdMap = {};
let elementIdCount = 0;

function cloneDeep(obj) {
  //   筛选，如果是引用数据类型则进入if
  if (Array.isArray(obj) || typeof obj === 'object') {
    // 创建变量接受深拷贝数据，如果obj是数组，则变量初始化为数组
    const cloneObj = Array.isArray(obj) ? [] : {};
    //   将变量进行遍历
    Object.keys(obj).forEach((key) => {
      //   如果被拷贝对象为引用数据，则将递归后的数据放入对应的键内
      if (Array.isArray(obj[key]) || typeof obj[key] === 'object') {
        cloneObj[key] = cloneDeep(obj[key]);
      } else {
        // 否则直接拷贝键值
        cloneObj[key] = obj[key];
      }
    });
    //   然后返回拷贝后的对象
    return cloneObj;
  }
  // 普通数据直接返回
  return obj;
}

function setUrlParam(name, value, link) {
  let url = link || location.href;
  const reg = new RegExp(`[?&#]${name}=([^&#]*)`, 'gi');

  const matches = url.match(reg);

  const key = `{key${new Date().getTime()}}`;
  let strArr;

  if (matches && matches.length > 0) {
    strArr = matches[matches.length - 1];
  } else {
    strArr = '';
  }

  const extra = `${name}=${value}`;

  // 当原url中含有要替换的属性:value不为空时，仅对值做替换,为空时，直接把参数删除掉
  if (strArr) {
    const first = strArr.charAt(0);
    url = url.replace(strArr, key);
    url = url.replace(key, value ? first + extra : '');
  } else if (value) {
    // 当原url中不含有要替换的属性且value值不为空时,直接在url后面添加参数字符串
    if (url.indexOf('?') > -1) {
      url += `&${extra}`;
    } else {
      url += `?${extra}`;
    }
  }
  // 其它情况直接返回原url
  return url;
}

const tool = {
  /**
           * 设置cookie
           * @param {string} key
           * @returns
           */
  getCookie: (key) => {
    const reg = new RegExp(`(^| )${key}=([^;]*)(;|$)`);
    const arr = document.cookie.match(reg);
    if (arr) {
      return arr[2];
    }
    return null;
  },
  /**
           * 设置cookie 冒号隔开
           * @param {string} str
           * @returns
           */
  setCookies: (str) => {
    const cookies = str.split(';');
    if (!cookies && !cookies.length) return;
    cookies.forEach(ck => (document.cookie = ck.replace(/\s$/, '')));
  },
  /**
           * 获取URL指定参数
           * @param {string} key
           * @param {string} url
           * @returns
           */
  getQueryparams: (key, link) => {
    const url = link || location.href;
    const reg = new RegExp(`(\\?|&)${key}=([^&]*)(&|$)`);
    const r = url.match(reg);
    if (r !== null) {
      return decodeURIComponent(r[2]);
    }
    return null;
  },
  /**
   * 设置url中指定的参数
   *
   * @param {string}
   *          name [参数名]
   * @param {string}
   *          value [参数值]
   * @param {string}
   *          url [发生替换的url地址|默认为location.href]
   * @return {string} [返回处理后的url]
   */
  setUrlParam,
  /**
   * 设置url中指定的参数
   * @param {*} params
   * @param {*} link
   * @returns
   */
  setUrlParams: (params, link) => {
    let url = link;
    Object.keys(params).forEach((k) => {
      url = setUrlParam(k, params[k], url);
    });
    return url;
  },
  /**
   * 动态加载JS
   * @param {string} id
   * @param {string} url
   * @param {function} callback
   */
  loadScript: (id, url, callback) => {
    const target = document.getElementById(id);
    if (target) {
      callback && callback();
    } else {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = id;
      script.src = url;
      script.onload = readystateFun;
      script.onreadystatechange = readystateFun;
      function readystateFun() {
        if (
          !script.readyState
          || script.readyState === 'loaded'
          || script.readyState === 'complete'
        ) {
          callback && callback();
        }
      };
      script.src = url;
      const head = document.getElementsByTagName('head')[0];
      head.appendChild(script);
    }
  },
  /**
           * 动态加载style
           * @param {*} url
           * @param {*} callback
           */
  loadStyle: (url, callback) => {
    if (typeof window !== 'undefined') {
      const target = window.document.querySelector(`link[href="${url}"]`);
      if (target) {
        callback && callback();
      } else {
        const node = window.document.createElement('link');
        node.rel = 'stylesheet';
        node.href = url;
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
  },
  // 获取新的ID
  genElementID: () => {
    let id = void 0;
    elementIdCount = elementIdCount + 1;
    do {
      id = ELEMENT_ID_PREFIX + elementIdCount;
      if (!elementIdMap[elementIdCount] && !document.getElementById(id)) break;
      elementIdMap[elementIdCount] = 1; // 占用全局ID防止意外重复
    } while (1);
    return id;
  },
  // Base64
  Base64,
  /**
           * 图片加载完成判断
           */
  loadImage: url => new Promise((resolve) => {
    let img = new Image();
    img.onload = function () {
      if (this.complete === true) {
        resolve(true);
        img = null;
      }
    };
    img.onerror = function () {
      resolve(false);
      img = null;
    };
    img.src = url;
  }),
  /**
           * 转换px 到rem
           * @param {*} style
           * @returns
           */
  transformStyle: (style) => {
    if (!style) {
      return {};
    }
    const styleObj = { ...style };
    const results = {};
    Object.entries(styleObj).forEach(([key, value]) => {
      if (value && /^[-]?[0-9]*[.]?[0-9]*px$/.test(value)) {
        results[key] = `${parseInt(value.substring(0, value.length - 2), 10) / 100}rem`;
      } else {
        results[key] = value;
      }
    });
    return results;
  },
  /**
           * 函数节流（时间戳+定时器)
           * @param {*} func
           * @param {*} delay
           * @returns
           */
  funcThrottle: (func, delay) => {
    let timer = null;
    let startTime = Date.now();
    return function (...args) {
      const curTime = Date.now();
      const remaining = delay - (curTime - startTime);
      clearTimeout(timer);
      if (remaining <= 0) {
        func.apply(this, args);
        startTime = Date.now();
      } else {
        timer = setTimeout(() => {
          func.apply(this, args);
        }, remaining);
      }
    };
  },
  cloneDeep,

};

export default tool;
